import { toast } from "react-toastify";

const initialState = {
  loading: false,
  error: null,
  list: null,
  info: null,
  sum: null,
  checkEmpty: false,
  isVerified: null,
};
export default function userFactor(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case "userFactor/myList":
      return { ...state, loading: false, list: data, error: null };
    case "userFactor/info":
      return { ...state, loading: false, info: data, error: null };
    case "userFactor/update":
      toast.success("درخواست شما با موفقیت انجام شد.");
      return { ...state, loading: false, error: null };
    case "userFactor/add":
      toast.success("درخواست شما با موفقیت انجام شد.");
      return { ...state, loading: false, error: null, sum: data.payPrice };
    case "userFactor/deleteUserOffCode":
      return { ...state, loading: false, error: null };
    case "userFactor/payment":
      window.location.replace(data);
      return { ...state, loading: false, error: null, isVerified: false };
    case "userFactor/verify":
      return { ...state, loading: false, error: null, isVerified: true };
    case "userFactor/loading":
      return { ...state, loading: true };
    case "userFactor/error":
      toast.error(data.message);
      return { ...state, loading: false, error: data.message };
    default:
      return state;
  }
}
